import React from 'react'
import { Form } from 'react-bootstrap'
import { Button } from '@abroad/components'
const QuestPaymentMethods = ({
  onMethodSelect,
  onContinue,
  selected,
  supportedPaymentMethods = {},
  isLoading = false,
}) => {
  const handleSelect = (value) => {
    if (onMethodSelect) onMethodSelect(value)
  }

  // // Convert object to array for mapping
  // let paymentMethodsArray = Object.entries(supportedPaymentMethods)
  // // Move 'credit_card' to the end
  // paymentMethodsArray = paymentMethodsArray.sort(([a], [b]) => {
  //   if (a === 'credit_card') return 1
  //   if (b === 'credit_card') return -1
  //   return 0
  // })
  const paymentMethodsArray = Object.entries(supportedPaymentMethods)

  // Check if selected method is valid (exists in supportedPaymentMethods)
  const isMethodSelected = selected && supportedPaymentMethods[selected]

  return (
    <>
      <div className='mt-30px'>
        <Form>
          {paymentMethodsArray.map(([key, method]) => {
            let label = method.displayName
            if (key === 'credit_card') {
              label = 'Credit Card'
            } else if (key === 'ach') {
              label = 'ACH (US ONLY)'
            } else if (key === 'klarna') {
              label = 'Klarna'
            } else if (key === 'sepa') {
              label = 'SEPA'
            } else if (key === 'wire_transfer') {
              // label = 'Wire Transfer
              label = 'ACH (US ONLY)'
            }
            return (
              <Form.Group key={key} className='mb-3 custom-radio'>
                <Form.Check
                  id={key}
                  custom={true}
                  onChange={() => handleSelect(key)}
                  checked={selected === key}
                  type='radio'
                  name='paymentMethod'
                  className='cursor-pointer d-flex align-items-center'>
                  <Form.Check.Input
                    id={key}
                    onChange={() => handleSelect(key)}
                    checked={selected === key}
                    type='radio'
                    name='paymentMethod'
                    className='cursor-pointer me-3 mt-0'
                  />
                  <Form.Check.Label className='checkbox-label s6a cursor-pointer'>
                    {label}
                  </Form.Check.Label>
                </Form.Check>
              </Form.Group>
            )
          })}
          <div className='d-flex justify-content-end mt-4'>
            <Button
              variant='saffron'
              className='border-radius-normal border-none mt-2 mt-sm-0 w-100'
              onClick={onContinue}
              isLoading={isLoading}
              disabled={isLoading || !isMethodSelected}>
              CONTINUE
            </Button>
          </div>
        </Form>
      </div>
    </>
  )
}

export default QuestPaymentMethods
